import React from 'react';
import LayoutSimple from '../components/layout/LayoutSimple';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <LayoutSimple>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white shadow-xl rounded-2xl p-8 md:p-12 border border-blue-50"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-8 border-b pb-4">Terms of Service</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">1. Acceptance of Terms</h2>
              <p>By accessing and using this Dynamic CRM platform, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">2. Description of Service</h2>
              <p>We provide a multi-tenant CRM software-as-a-service (SaaS) including lead management, customer tracking, and analytics tools. We reserve the right to modify or discontinue services at any time.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">3. User Accounts</h2>
              <p>You are responsible for maintaining the confidentiality of your account credentials. Any activity under your account is your responsibility. You must notify us immediately of any unauthorized use.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">4. Usage Limits</h2>
              <p>Usage is subject to the limits defined in your selected subscription plan (users, leads, storage). Exceeding these limits may require an upgrade or incur additional charges.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">5. Data Ownership</h2>
              <p>You retain all rights to the data you upload. We claim no ownership over your business information. However, you grant us a license to host and process this data to provide the service.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">6. Governing Law</h2>
              <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in India.</p>
            </section>

            <p className="text-sm pt-8 border-t text-slate-400">Last updated: April 2026</p>
          </div>
        </motion.div>
      </div>
    </LayoutSimple>
  );
};

export default TermsOfService;
